import { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Container from "react-bootstrap/Container";
import NavBar from "./Navbar/Navbar";

import Register from "../src/login/Register";
import Logout from "../src/login/logout";
import AdminPanel from "./admin/admin";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "../src/login/Login";

type MyProps = {};
type MyState = {
    calculating: boolean;
};

class App extends Component<MyProps, MyState> {
  constructor(props: MyState) {
    super(props);

    // Set initial state
    this.state = {calculating: false};

    // Binding this keyword
    this.setUser = this.setUser.bind(this);
  }
  setUser(
    user: string,
    roles: string,
    accessToken: string,
    id: number,
    language?: string
  ) {
    const normalizedLanguage = (language || "NL").toUpperCase();
    const selectedLanguage = ["NL", "FR", "EN"].includes(normalizedLanguage)
      ? normalizedLanguage
      : "NL";

    sessionStorage.setItem("user", JSON.stringify(user));
    sessionStorage.setItem("accessToken", JSON.stringify(accessToken));
    
    sessionStorage.setItem("userid", JSON.stringify(id));
    sessionStorage.setItem("role", roles);
    sessionStorage.setItem("language", selectedLanguage);

    sessionStorage.setItem("nodeId", "5");
    //sessionStorage.setItem("status", JSON.stringify(true));
    sessionStorage.setItem("uitvoeringText", "");
    sessionStorage.setItem("uitvoering", "");

    //sessionStorage.setItem("pakketten", JSON.stringify(false));
    //sessionStorage.setItem("rel04_08", JSON.stringify(false));


    sessionStorage.removeItem("projectId");
    sessionStorage.removeItem("eindklant");
    sessionStorage.removeItem("eindklantId");
    sessionStorage.removeItem("bestandsnaam");
    sessionStorage.removeItem("woningTree");
    sessionStorage.removeItem("loadedWoning");
    sessionStorage.removeItem("offerteModules");

    localStorage.setItem("expandedTreeNodes", JSON.stringify(['1']));
  }

 

  handleLoadedWoningChange(arr: any) {
    //console.log("APP ARR: ", arr)
  }

  

  render() {
    return (
      <Container className="AppContainer">
        <main className="App">
          <Router>
            <Routes>
              <Route path="/register" element={<Register />} />
              <Route path="/logout" element={<Logout />} />
              <Route
                path="/login"
                element={<Login onSetToken={this.setUser} />}
              />
              <Route
                path="/"
                element={
                  <NavBar
                    //onLoadedWoningChange={this.handleLoadedWoningChange}
                  />
                }
              />
              <Route path="/admin" element={<AdminPanel />} />
            </Routes>
          </Router>
        </main>
      </Container>
    );
  }
}

export default App;
